<script setup>
import { ref } from "vue"
import bus from "../utils/eventBus.js"
import FeedService from "../services/FeedService.js"
import { useFilteredFeedStore } from "../utils/store.js"
const store = useFilteredFeedStore()

function doSearch(){
	bus.emit('go')
	if (store.filters) {
		store.fetchItems()
	}
}

</script>

<template>
	<div class="py-6 flex flex-col md:flex-row flex-wrap gap-8 md:items-center md:justify-between">
		<div class="flex flex-col md:flex-row flex-wrap md:items-center gap-8 w-full md:w-auto">
			<span>Search by keyword</span>
			<input type="text" class="form-field" v-model="store.filters.keyword" @keyup.enter="doSearch()" placeholder="Enter keywords">
		</div>

		<div class="flex flex-wrap gap-y-8 gap-x-12">
			<div class="flex items-center gap-4">
				<button 
				class="block size-6 border-2 border-white" 
				id="t1" 
				@click.prevent="
					store.updateFilters({
						taxonomy: 'a11y',
						term: 'show'
					})
				" :class="{
						'bg-white': store.inFilters('show', 'a11y'),
				}"></button>
				<label for="t1" class="text-sm cursor-pointer">Show accessible performances only</label>
			</div>

			<div class="flex items-center gap-4">
				<button 
				class="block size-6 border-2 border-white" 
				id="t2" 
				@click.prevent="
					store.updateFilters({
						taxonomy: 'brightsparks',
						term: 'show'
					})
				" :class="{
						'bg-white': store.inFilters('show', 'brightsparks'),
				}"></button>
				<label for="t2" class="text-sm cursor-pointer">Show Bright Sparks classes only</label>
			</div>
		</div>
	</div>
</template>